(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pakyo-404"]) return;
  try {
    
  (() => {
    const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const fold = t => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    const flag = iso => iso && /^[A-Za-z]{2}$/.test(iso) ? 'https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/1x1/' + iso.toLowerCase() + '.svg' : '';
    // countries.json `from` is supplier cost in USD → retail (plan B) → shopper currency.
    const money = cost => {
      const P = window.Pakyo || {};
      const pr = P.pricing || { mult: 1.7, fixed: 1.5 };
      const p = cost * pr.mult + pr.fixed;
      const usd = p < 10 ? Math.ceil(p * 2) / 2 - 0.01 : Math.ceil(p) - 0.01;
      // pakyo.js rounds like Shopify Markets (per-currency steps); plain USD if it hasn't loaded
      const cents = P.localCents ? P.localCents(usd) : Math.round(usd * 100);
      return P.formatMoney ? P.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
    };
    // Same resolution as pakyo.js: destination page → product page (theme setting product_handles) → destinations search.
    const hrefFor = name => {
      const P = window.Pakyo || {};
      const key = name.toLowerCase();
      const dest = (P.destinations || {})[key];
      if (dest) return dest;
      let handle = '';
      (P.productHandles || '').split('\n').some(line => {
        const i = line.indexOf(':');
        if (i > 0 && line.slice(0, i).trim().toLowerCase() === key) { handle = line.slice(i + 1).trim(); return true; }
        return false;
      });
      return handle && P.routes ? P.routes.productPrefix + handle : '/pages/destinations?q=' + encodeURIComponent(name);
    };

    const init = root => {
      const $ = sel => root.querySelector(sel);
      const params = new URLSearchParams(location.search);
      const q0 = params.get('q') || '';
      const posted = !!$('[data-nf-posted]');
      const S = { cs: [], q: q0 };

      if (q0) {
        $('[data-nf-kicker]').textContent = root.dataset.kickerDest;
        $('[data-nf-title]').textContent = root.dataset.titleDest;
        $('[data-nf-sub]').textContent = root.dataset.subDest;
      }
      const input = $('[data-nf-q]');
      input.value = q0;

      // shown in the page language (window.PT); links and search keep the English name
      const nm = c => window.PT ? PT.country(c.key || c.iso, c.name) : c.name;
      const row = c => ({ name: nm(c), flag: flag(c.iso), from: money(c.from), href: hrefFor(c.name) });
      const render = () => {
        const t = fold(S.q.trim());
        const res = t ? S.cs.filter(c => fold([c.name, nm(c)].concat(c.aka || []).join(' | ')).includes(t)).slice(0, 5).map(row) : [];
        const box = $('[data-nf-results]');
        box.innerHTML = res.map(r => `<a class="nf-row" href="${esc(r.href)}">${r.flag ? `<img class="flag" src="${esc(r.flag)}" alt="" width="30" height="30" loading="lazy">` : ''}<span class="nf-row__name">${esc(r.name)}</span><span class="nf-row__from">${esc(window.PT ? PT('from', { price: r.from }) : 'from ' + r.from)}</span></a>`).join('');
        box.hidden = !res.length;

        const noMatch = !!t && S.cs.length > 0 && !res.length;
        $('[data-nf-none]').hidden = !(noMatch || (posted && !t));
        const title = $('[data-nf-none-title]');
        title.textContent = title.dataset.template.replace('[q]', S.q.trim());
        $('[data-nf-none-text]').hidden = !noMatch;
        const body = $('[data-nf-body]');
        if (body) body.value = 'Destination request (404 search): ' + S.q.trim();
      };

      const renderPopular = () => {
        const names = (root.dataset.popular || '').split(',').map(s => s.trim()).filter(Boolean);
        $('[data-nf-popular]').innerHTML = names.map(n => S.cs.find(c => c.name === n)).filter(Boolean).map(row)
          .map(p => `<a class="nf-pill" href="${esc(p.href)}">${p.flag ? `<img class="flag" src="${esc(p.flag)}" alt="" width="28" height="28" loading="lazy">` : ''}<span>${esc(p.name)}</span></a>`).join('');
      };

      input.addEventListener('input', () => { S.q = input.value; render(); });
      render();

      const url = window.Pakyo && Pakyo.data && Pakyo.data.countries;
      if (url) fetch(url).then(r => r.json()).then(cs => { S.cs = Array.isArray(cs) ? cs : []; render(); renderPopular(); }).catch(() => {});
    };

    const run = () => document.querySelectorAll('[data-nf-root]:not([data-nf-ready])').forEach(root => { root.dataset.nfReady = '1'; init(root); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-contact"]) return;
  try {
    
(function () {
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function init(root) {
    if (!root || root.dataset.contactReady) return;
    root.dataset.contactReady = '1';
    var form = root.querySelector('.contact-form');
    if (!form) return;
    var email = form.querySelector('[data-contact-email]');
    var body = form.querySelector('[data-contact-body]');
    var topic = form.querySelector('[data-contact-topic]');

    form.addEventListener('click', function (e) {
      var chip = e.target.closest('.contact-chip');
      if (!chip) return;
      form.querySelectorAll('.contact-chip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (topic) topic.value = chip.dataset.value;
    });

    // The button stays red as in the design; an invalid form is stopped here with the browser's own hints.
    form.addEventListener('submit', function (e) {
      var ok = email && body && EMAIL.test(email.value.trim()) && body.value.trim();
      if (ok) return;
      e.preventDefault();
      if (email && !EMAIL.test(email.value.trim())) email.setCustomValidity(form.dataset.emailInvalid);
      if (!form.reportValidity()) (form.querySelector(':invalid') || email).focus();
    });
    if (email) email.addEventListener('input', function () { email.setCustomValidity(''); });
  }
  function boot() { document.querySelectorAll('[data-contact]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-data-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-dc]').forEach(function (root) {
      var margin = parseFloat(root.getAttribute('data-margin')) || 0;
      var heavy = parseFloat(root.getAttribute('data-heavy')) || 2;
      var attr = function (k) { return root.getAttribute('data-' + k) || ''; };
      var q = function (sel) { return root.querySelector(sel); };
      var days = 7;
      var on = root.querySelector('[data-dc-day][aria-pressed="true"]');
      if (on) days = parseInt(on.getAttribute('data-dc-day'), 10);

      function fmt(n) { return String(Math.round(n * 10) / 10); }

      function render() {
        var perDay = 0;
        root.querySelectorAll('[data-dc-act]').forEach(function (b) {
          if (b.getAttribute('aria-pressed') === 'true') perDay += parseFloat(b.getAttribute('data-gb')) || 0;
        });
        perDay = Math.round(perDay * 100) / 100;
        var total = perDay * days * (1 + margin / 100);
        var perDayLabel = perDay.toFixed(1) + ' GB';
        var title, text;
        if (perDay === 0) {
          title = attr('rec-none-title'); text = attr('rec-none-text');
        } else if (perDay >= heavy) {
          title = attr('rec-heavy-title'); text = attr('rec-heavy-text').replace('[gb]', perDayLabel);
        } else if (total > 20) {
          title = attr('rec-big-title'); text = attr('rec-big-text');
        } else {
          var rec = total <= 3 ? '3 GB' : total <= 5 ? '5 GB' : total <= 10 ? '10 GB' : '20 GB';
          title = attr('rec-plan-title').replace('[plan]', rec); text = attr('rec-plan-text');
        }
        q('[data-dc-total]').textContent = perDay === 0 ? '—' : fmt(Math.round(total * 2) / 2) + ' GB';
        q('[data-dc-perday]').textContent = '~' + perDayLabel;
        q('[data-dc-days-label]').textContent = attr('days-label').replace('[days]', days);
        q('[data-dc-rec-title]').textContent = title;
        q('[data-dc-rec-text]').textContent = text;
      }

      root.addEventListener('click', function (e) {
        var day = e.target.closest('[data-dc-day]');
        if (day && root.contains(day)) {
          days = parseInt(day.getAttribute('data-dc-day'), 10);
          root.querySelectorAll('[data-dc-day]').forEach(function (b) { b.setAttribute('aria-pressed', b === day ? 'true' : 'false'); });
          render();
          return;
        }
        var act = e.target.closest('[data-dc-act]');
        if (act && root.contains(act)) {
          act.setAttribute('aria-pressed', act.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          render();
        }
      });
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-help"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.helpReady) return;
    root.dataset.helpReady = '1';
    var input = root.querySelector('[data-help-q]');
    // Phones: the long placeholder ("… e.g. refund, hotspot, roaming") gets cut off — use the short form.
    if (input && input.dataset.short) {
      var full = input.placeholder, mq = window.matchMedia('(max-width: 520px)');
      var fit = function () { input.placeholder = mq.matches ? input.dataset.short : full; };
      fit(); if (mq.addEventListener) mq.addEventListener('change', fit);
    }
    var clear = root.querySelector('[data-help-clear]');
    var browse = root.querySelectorAll('[data-help-browse]');
    var results = root.querySelector('[data-help-results]');
    var line = root.querySelector('[data-help-line]');
    var list = root.querySelector('[data-help-list]');
    var empty = root.querySelector('[data-help-empty]');
    var emptyQ = root.querySelector('[data-help-empty-q]');
    var items = Array.prototype.map.call(root.querySelectorAll('[data-help-item]'), function (el) {
      var q = el.querySelector('.help-q__text'), a = el.querySelector('.faq__a');
      return { el: el, section: el.dataset.section || '', text: ((q ? q.textContent : '') + ' ' + (a ? a.textContent : '')).toLowerCase() };
    });

    function closeAll() {
      root.querySelectorAll('.faq__item.is-open').forEach(function (it) {
        it.classList.remove('is-open');
        var b = it.querySelector('.faq__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    function clone(it) {
      var c = it.el.cloneNode(true);
      c.classList.remove('is-open');
      c.removeAttribute('data-help-item');
      c.removeAttribute('data-shopify-editor-block');
      var btn = c.querySelector('.faq__q');
      btn.setAttribute('aria-expanded', 'false');
      btn.removeAttribute('aria-controls');
      var ans = c.querySelector('.faq__a');
      if (ans) ans.removeAttribute('id');
      var lab = document.createElement('span');
      lab.className = 'help-q__sec';
      lab.textContent = it.section;
      c.querySelector('.help-q').insertBefore(lab, c.querySelector('.help-q').firstChild);
      return c;
    }

    function render() {
      var raw = input.value.trim(), t = raw.toLowerCase();
      clear.hidden = !input.value;
      browse.forEach(function (el) { el.hidden = !!t; });
      results.hidden = !t;
      if (!t) { list.textContent = ''; return; }
      var hits = items.filter(function (it) { return it.text.indexOf(t) !== -1; });
      list.textContent = '';
      hits.forEach(function (it) { list.appendChild(clone(it)); });
      line.textContent = (hits.length === 1 ? root.dataset.one : root.dataset.many).replace('{n}', hits.length).replace('{q}', raw);
      empty.hidden = hits.length > 0;
      emptyQ.textContent = raw;
    }

    input.addEventListener('input', function () { closeAll(); render(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { input.value = ''; render(); }
      if (e.key === 'Enter') e.preventDefault();
    });
    clear.addEventListener('click', function () { input.value = ''; render(); input.focus(); });

    var pre = new URLSearchParams(location.search).get('q');
    if (pre) { input.value = pre; closeAll(); render(); }
  }

  function boot() { document.querySelectorAll('[data-help]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hiw]').forEach(function (root) {
      root.addEventListener('click', function (e) {
        var osBtn = e.target.closest('[data-hiw-os]');
        if (osBtn && root.contains(osBtn)) {
          var os = osBtn.getAttribute('data-hiw-os');
          root.setAttribute('data-os', os);
          root.querySelectorAll('[data-hiw-os]').forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-hiw-os') === os ? 'true' : 'false');
          });
          return;
        }
        var apn = e.target.closest('[data-hiw-apn]');
        if (apn && root.contains(apn)) {
          var panel = document.getElementById(apn.getAttribute('aria-controls'));
          var open = apn.getAttribute('aria-expanded') !== 'true';
          apn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-legal"]) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.legalReady) return;
      root.dataset.legalReady = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-legal-tab]'));
      var panels = root.querySelectorAll('[data-legal-panel]');
      var title = root.querySelector('[data-legal-title]');
      var docs = tabs.map(function (t) { return t.getAttribute('data-legal-tab'); });

      function norm(d) {
        if (d === 'refund') d = 'refunds';
        return docs.indexOf(d) > -1 ? d : null;
      }
      function show(d) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-legal-tab') === d;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on && title) title.textContent = t.getAttribute('data-title');
        });
        Array.prototype.forEach.call(panels, function (p) {
          p.hidden = p.getAttribute('data-legal-panel') !== d;
        });
      }

      var params = new URLSearchParams(window.location.search);
      var initial = norm(params.get('doc')) || root.getAttribute('data-default-doc') || docs[0];
      show(initial);
      if (window.location.hash) {
        var target = document.getElementById(window.location.hash.slice(1));
        if (target && root.contains(target)) target.scrollIntoView();
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var d = t.getAttribute('data-legal-tab');
          show(d);
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('doc', d);
            u.hash = '';
            history.replaceState(null, '', u);
          } catch (e) {}
          window.scrollTo(0, 0);
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-legal-page]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-legal-page]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-phone-check"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      const S = { os: null, ans: null };
      const q = sel => root.querySelectorAll(sel);
      const render = () => {
        q('[data-pc-os]').forEach(b => { const on = b.dataset.pcOs === S.os; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
        q('[data-pc-ans]').forEach(b => { const on = b.dataset.pcAns === S.ans; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
        root.querySelector('[data-pc-more]').hidden = !S.os;
        q('[data-pc-steps]').forEach(el => { el.hidden = el.dataset.pcSteps !== S.os; });
        q('[data-pc-os-text]').forEach(el => { el.hidden = el.dataset.pcOsText !== S.os; });
        q('[data-pc-result]').forEach(el => { el.hidden = el.dataset.pcResult !== S.ans; });
      };
      q('[data-pc-os]').forEach(b => b.addEventListener('click', () => { S.os = b.dataset.pcOs; S.ans = null; render(); }));
      q('[data-pc-ans]').forEach(b => b.addEventListener('click', () => { S.ans = b.dataset.pcAns; render(); }));
      render();
    };
    const run = () => document.querySelectorAll('[data-pc-root]:not([data-pc-ready])').forEach(root => { root.dataset.pcReady = '1'; init(root); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-price-index"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.piReady) return;
    var body = root.querySelector('[data-pi-body]');
    var tools = root.querySelector('[data-pi-tools]');
    if (!body || !tools) return;
    root.dataset.piReady = '1';
    var rows = Array.prototype.slice.call(body.querySelectorAll('[data-pi-row]'));
    var num = function (v) { return v === '' || v == null ? 1e9 : parseFloat(v); };
    var cmp = {
      pergb: function (a, b) { return num(a.dataset.pergb) - num(b.dataset.pergb) || num(a.dataset.min) - num(b.dataset.min); },
      min: function (a, b) { return num(a.dataset.min) - num(b.dataset.min) || num(a.dataset.pergb) - num(b.dataset.pergb); },
      name: function (a, b) { return a.dataset.name.localeCompare(b.dataset.name, document.documentElement.lang || 'en'); }
    };
    function sort(key) {
      rows.sort(cmp[key]);
      var frag = document.createDocumentFragment();
      rows.forEach(function (r) { frag.appendChild(r); });
      body.appendChild(frag);
      root.querySelectorAll('[data-pi-sort]').forEach(function (b) {
        var on = b.dataset.piSort === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pi-col]').forEach(function (th) {
        if (th.dataset.piCol === key) th.setAttribute('aria-sort', 'ascending'); else th.removeAttribute('aria-sort');
      });
    }
    tools.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pi-sort]');
      if (b) sort(b.dataset.piSort);
    });
    tools.hidden = false;
    sort('pergb');
  }
  function boot() { document.querySelectorAll('[data-pi-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pakyo-setup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-su]').forEach(function (root) {
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-su-os]');
        if (!btn || !root.contains(btn)) return;
        var os = btn.getAttribute('data-su-os');
        root.setAttribute('data-os', os);
        root.querySelectorAll('[data-su-os]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-su-os') === os ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
